import 'jquery-ui';
import ko from 'knockout';
import { BlockPageHelper } from '../Helpers/helpers';
import { post } from "jquery";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import { Toast } from "bootstrap";
const Genesis = require("../Genesis.js");
import { QRCodeScanner } from "../Components/QRCodeScanner";
import { CategoryPathComponent } from '../Shared/CategoryPath/CategoryPathComponent';
import { int } from '@zxing/library/esm/customTypings';
import { ISiteMobileDocumentCaptureImagePage } from '../Document/ISiteMobileDocumentCaptureImagePage';
let AutoComplete = require("./serviceRequestSearch.js");

interface PendingUploadFile {
    name: string;
    type: string;
    content: string;
    title?: string;
    libraryName?: string;
    secondaryId?: string;
}
export class ISiteMobileServiceRequestCreateSRPage {
    private readonly startButton = document.getElementById('scanButton');
    private qrCodeScanner: QRCodeScanner | null = new QRCodeScanner;
    private qrNotFoundmodal: Modal | null = null;
    private readonly qrNotFoundModalElement = document.getElementById("qrNotFound-modal");
    private modal: Modal | null = null;
    private PropertyId: string = "";
    private LocationId: string = "";
    private readonly idConfirmModal = document.getElementById("photoEvidenceModal");
    private readonly modalEl = document.getElementById("photoModal");
    private confirmModal: Modal | null = null;
    private cameraModal: Modal | null = null;

    private category: CategoryPathComponent = new CategoryPathComponent({
        ModalId: 'classificationModal',
        Url: Genesis.url('/WorkOrder/_CategoryPath'),
        PathId: 'categoryPath',
        SelectButtonId: 'selectCategoryButton',
        IsReadOnly: false,
        PreventParentSelection: true,
        AllowMultiSelect: false,
        IsRequired: true,
        FormId: "CreateSRForm"
    });

    constructor() {

        if (this.qrNotFoundModalElement !== null) {
            this.qrNotFoundmodal = new Modal(this.qrNotFoundModalElement, { backdrop: 'static', keyboard: false });
        }

        if (this.idConfirmModal !== null) {
            this.confirmModal = new Modal(this.idConfirmModal, { backdrop: 'static', keyboard: false });
        }
        if (this.modalEl !== null) {
            this.cameraModal = new Modal(this.modalEl, { backdrop: 'static', keyboard: false });
        }
    }

    public Init() {
        var that = this;
        AutoComplete();
        this.PropertyId = $('#RelatedProperty').val() as string;
        this.LocationId = $("#LocationId").val() as string;

        if (this.PropertyId != "") {
            this.PopulateLocationDropdown(this.PropertyId, this.LocationId);
        }
        $("#idPreview").html('');
        $("#idPreview").hide();
        $("#frmContent").show();
        $("#hdnProcess").val("Edit");
        $("#classificationModal").detach().appendTo("#modalContainerPlaceholder");

        let $elements = $("[id^='classificationModal']");
        while ($elements.length >= 2) {
            $elements.first().remove();
            $elements = $("[id^='classificationModal']");
        }


        try {
            ko.applyBindings(this.category);
        }
        catch (e) {
            // Bindings already created, no need to do anything
        }

        $('#CreateSRForm').off('submit');

        $("#btn-cancel").click((e: any) => {
            BlockPageHelper.block();
            $("#hdnProcess").val("Edit");

            const cancelText = $("#btn-cancel").text().trim();
            if (cancelText.toLowerCase() === "cancel") {
                window.location.href = Genesis.url('/ServiceRequest/MyServiceRequests');
            }
            else {
                $("#idPreview").html('');
                $("#frmContent").show();
                $("#idPreview").hide();
            }
            $("#btn-cancel").text("Cancel");
            $("#saveSR").text("Save");
            BlockPageHelper.unblock();
        });

        var $input = $("#assetSearch");
        var $button = $("#scanButton");

        // Insert the button right after the input
        $input.after($button);
        $("#saveSR").click((e: any) => {
            BlockPageHelper.block();
            if ($("#hdnProcess").val() == "Edit") {
                const form = $('#CreateSRForm')[0] as HTMLFormElement;
                if (form !== null) {
                    this.category.validateCategorySelected();
                    if (!form.checkValidity()) {
                        form.classList.add('was-validated');
                        BlockPageHelper.unblock();
                        return false;
                    }
                    else {

                        var isSimplifiedServiceRequest = $("#IsSimplifiedServiceRequest").val();
                        if (isSimplifiedServiceRequest === "True") {

                            var _recordId = $('#RecordId').val() as int;
                            const pendingUploads = localStorage.getItem("pendingUploads");

                            if (_recordId == undefined && pendingUploads == null) {
                                this.confirmModal?.show();
                                $("#evidanceConfirm").click(function () {
                                    const checkbox = $('#confirmToggle');
                                    const isChecked = checkbox.prop('checked');
                                    checkbox.prop('checked', !isChecked).trigger('change');
                                });
                            }
                            else {
                                this.PreviewSRForm();
                            }
                        }
                        else {
                            this.PreviewSRForm();
                        }
                    }
                }
            }
            else {
                this.SubmitSRForm();
            }
        });

        $("#assetSearchbtn").click(function () {
            that.SearchAsset();
        });

        $("#idConfirm").click(function () {
            BlockPageHelper.unblock();
            const isChecked = $('#confirmToggle').prop('checked');
            if (isChecked) {
                const pendingUploads = localStorage.getItem('pendingUploads');
                if (!pendingUploads) {
                    that.confirmModal?.hide();
                    that.HandleSaveForLaterClick();
                }
                else {
                    that.confirmModal?.hide();
                    that.PreviewSRForm();
                }
            }
            else {
                that.confirmModal?.hide();
                that.PreviewSRForm();
            }
        });

        $("#idCancel").click(function () {
            BlockPageHelper.unblock();
            that.confirmModal?.hide();
        });


        $("#openPhotoModal").click(() => {
            const photoPage = new ISiteMobileDocumentCaptureImagePage();
            photoPage.isStoreLocal = true;
            const modalEl = document.getElementById('photoModal');
            photoPage.resetCamera();
            if (modalEl) {
                modalEl.addEventListener('shown.bs.modal', () => {
                    const modalBody = modalEl.querySelector('.modal-body') as HTMLElement;
                    const canvas = document.getElementById('canvas') as HTMLCanvasElement;
                    const video = document.getElementById('video') as HTMLVideoElement;
                    if (modalBody && canvas) {
                        canvas.height = modalBody.clientHeight;
                        canvas.width = modalBody.clientWidth;
                    }
                });
            }
            that.cameraModal?.show();
            photoPage.Init();
        });

        $('#modal-Scanner .modal-header a[data-bs-dismiss="modal"]').click(function () {
            that.qrCodeScanner?.stopScanning();
        });

        if (this.startButton) {
            this.startButton.addEventListener('click', async () => {
                await this.qrCodeScanner?.startScanning();
                const scannedCode = await this.qrCodeScanner?.scanBarcodeOrQRCode();
                if (scannedCode) {
                    var that = this;
                    that.qrCodeScanner?.stopScanning("Please Wait");
                    $.get(Genesis.url('/Asset/ISQRCodeLinkAvail'), {
                        QRCodeLink: scannedCode
                    }, function (responseResult) {
                        if (responseResult != null) {
                            var value = "Asset/ViewAssetDetail?RecordId=" + responseResult.recordID;
                            window.location.href = Genesis.url(value);
                        }
                        else {
                            localStorage.removeItem('ScannedCode');
                            localStorage.setItem('ScannedCode', scannedCode);
                            that.qrNotFoundmodal?.show();
                        }
                        that.qrCodeScanner?.stopScanning();
                    });
                }
            });
        }

        var existingCategory = $("#Category").val() as string;
        var existingCategoryId = $("#SelectedCategoryId").val() as string;

        if (existingCategory != '') {
            $('.categoryPathName').text(existingCategory);
            $('#CategoryId').val(existingCategoryId).attr('value', existingCategoryId);

        }
        localStorage.removeItem("pendingUploads");

        $("#saveForLaterButton").click(() => {
            this.HandleSaveForLaterClick();
        });
    }

    private HandleSaveForLaterClick() {
        const fileInput = document.getElementById("uploadFileInput") as HTMLInputElement;
        fileInput.removeEventListener("change", this.fileInputChangeHandler); // clean old
        fileInput.addEventListener("change", this.fileInputChangeHandler);    // add fresh
        fileInput.click();
    }

    private fileInputChangeHandler = (event: Event) => {
        const input = event.target as HTMLInputElement;
        const files = input.files;
        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                console.log("Selected file:", file);
                this.SavePendingUpload(file);
            }
            Swal.fire({ text: `File was uploaded successfully` });
        } else {
            Swal.fire({ text: `Please select at least one file to save.` });
        }

        // Clear value so user can re-select the same file
        input.value = "";
    };


    private SavePendingUpload(file: File) {
        const reader = new FileReader();
        const that = this;
        reader.onload = function (event) {
            const fileData = {
                name: file.name,
                type: file.type,
                size: file.size,
                content: event.target?.result
            };

            let pendingUploads: any[] = JSON.parse(localStorage.getItem("pendingUploads") || "[]");
            pendingUploads.push(fileData);
            localStorage.setItem("pendingUploads", JSON.stringify(pendingUploads));
            that.updateBadgeCount();
        };
        reader.readAsDataURL(file);
    }

    private updateBadgeCount() {
        const pendingUploads = JSON.parse(localStorage.getItem("pendingUploads") || "[]");
        const badge = document.getElementById("badgeCount") as HTMLElement;
        if (pendingUploads.length > 0) {
            badge.style.display = 'inline';
            badge.textContent = pendingUploads.length.toString();
        } else {
            badge.style.display = 'none';
        }
    }

    private base64ToFile(base64: string, filename: string, type: string): File {
        const byteString = atob(base64.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new File([ab], filename, { type: type });
    }

    private PreviewSRForm() {
        $("#hdnProcess").val("Preview");
        const formData = $("#CreateSRForm").serialize();
        var saveSR: { [key: string]: string } = {};
        $.each(formData.split("&"), function (index, item) {
            var pair = item.split("=");
            saveSR[pair[0]] = decodeURIComponent(pair[1]);
        });
        const $locationDropdown = $("#locationsDropdown");
        const $priorityDropdown = $("#PriorityID");
        saveSR["LocationId"] = $locationDropdown.val()?.toString() || "0";
        saveSR["Location"] = $locationDropdown.find("option:selected").text();
        saveSR["PriorityID"] = $priorityDropdown.val()?.toString() || "0";
        saveSR["ReportedPriority"] = $priorityDropdown.find("option:selected").text();


        const url = Genesis.url('/ServiceRequest/PreviewSaveSR');
        $.post(url, { saveSR: saveSR }, function (responseResult) {
            $("#idPreview").html('');
            $("#frmContent").hide();
            $("#idPreview").show();
            BlockPageHelper.unblock();
            $("#idPreview").html(responseResult);
            $("#btn-cancel").text("Edit");
            $("#saveSR").text("Submit");
            $('#btn-cancel').prepend('<i class="fas fa-edit"></i> ')
        });
    }

    private SubmitSRForm() {

        var value = $('.categoryPathName').text();
        $('#Category').val(value);

        this.SubmitSR();

    }

    private SubmitSR() {

        this.confirmModal?.hide();
        const formData = $("#CreateSRForm").serialize();
        var saveSR: { [key: string]: string } = {};
        $.each(formData.split("&"), function (index, item) {
            var pair = item.split("=");
            saveSR[pair[0]] = decodeURIComponent(pair[1]);
        });
        const url = Genesis.url('/ServiceRequest/SaveSR');
        $.post(url, { saveSR: saveSR }, (responseResult) => {
            BlockPageHelper.unblock();
            $("#idPreview").html(responseResult);
            if (responseResult.status) {

                const pendingUploadsRaw = localStorage.getItem('pendingUploads');
                const pendingUploads: PendingUploadFile[] = pendingUploadsRaw ? JSON.parse(pendingUploadsRaw) : [];
                if (pendingUploads.length > 0) {
                    BlockPageHelper.block();
                    const recordId = responseResult.serviceRequestid;
                    const uploadFormData = new FormData();
                    pendingUploads.forEach((item) => {
                        const file = this.base64ToFile(item.content, item.name, item.type);
                        uploadFormData.append("files", file); // Append each file under 'files'
                    });

                    uploadFormData.append("recordId", recordId);
                    uploadFormData.append("libraryName", "Service Request Evidence");
                    uploadFormData.append("secondaryId", "0");
                    uploadFormData.append("fileTitle", "Uploaded Files");
                    uploadFormData.append("updateMainImage", "false");

                    $.ajax({
                        url: Genesis.url('/Document/UploadFiles'),
                        type: 'POST',
                        data: uploadFormData,
                        contentType: false,
                        processData: false,
                        success: (res) => {
                            BlockPageHelper.unblock();
                            localStorage.removeItem("pendingUploads");
                            var msgSuccess = Toast.getOrCreateInstance("#msgSuccess");
                            msgSuccess.show();
                            const redirectUrl = Genesis.url('/ServiceRequest/GetServiceRequest?requestId=') + responseResult.serviceRequestid;
                            window.location.href = redirectUrl;
                        },
                        error: (err) => {
                            console.error("Failed to upload files", err);
                        }
                    });
                }
                else {
                    localStorage.removeItem("pendingUploads");
                    var msgSuccess = Toast.getOrCreateInstance("#msgSuccess");
                    msgSuccess.show();
                    const redirectUrl = Genesis.url('/ServiceRequest/GetServiceRequest?requestId=') + responseResult.serviceRequestid;
                    window.location.href = redirectUrl;
                }
            }
            else {
                var msgFailure = Toast.getOrCreateInstance("#msgFailure");
                msgFailure.show();
            }
        });
    }

    private PopulateLocationDropdown(propId: string, locId: string) {
        $.ajax({
            type: "GET",
            url: "LocationFilter",
            data: { propertyId: propId },
            success: function (data) {
                var s = '<option value="0">Please Select a Location</option>';
                for (var i = 0; i < data.length; i++) {
                    s += '<option value="' + data[i].id + '">' + data[i].path + '</option>';
                }
                $("#locationsDropdown").html(s);
                if (locId != "0" && locId != "") {
                    $('#locationsDropdown option[value="' + locId + '"]').attr("selected", "selected");
                }
            }
        });

    }
    public SearchAsset() {
        var searchTerm = $("#assetSearch").val();
        var propertyid = $("#PropertyId").val();
        var locationid = $("#LocationId").val();

        $.ajax({
            type: "GET",
            url: "GetAssetsForSearch",
            dataType: "html",
            data: { searchTerm: searchTerm, propertyId: propertyid, locationId: locationid },
            success: function (data) {
                $("#filteredPlaceHolder").html(data);
            }
        });
    }
};